import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux'
import { RootState } from '../store'

type DisplayFightState = {
    selectedFightId: string
    selectedSetupId: string | undefined
}

const initialState: DisplayFightState = {
    // Force into undefined on init, but must always be set before the
    // app gets up and running
    selectedFightId: (undefined as unknown as string),
    selectedSetupId: undefined,
}

const slice = createSlice({
    name: "display-fight",
    initialState,
    reducers: {

        selectFight: (state, action: PayloadAction<{ fightId: string }>) => {
            return {
                ...state,

                selectedFightId: action.payload.fightId,
                // Automatically wipe the setup as we changed fight
                selectedSetupId: undefined
            }

        },

        selectSetup: (state, action: PayloadAction<{ selectedSetupId: string }>) => {
            return {
                ...state,
                selectedSetupId: action.payload.selectedSetupId
            }
        },

        clearSelectedSetup: (state) => {
            return {
                ...state,
                selectedSetupId: undefined,
            }
        }

    }
})

export const DisplayFightActions = slice.actions
export const DisplayFightReducer = slice.reducer

export const useDisplayState = () => useSelector<RootState, DisplayFightState>(s => s.displayFight)
